export const menuTitle = { title: "SALARY TYPE", label: "Salary Type" }
  